import { Bone, SkeletonGrid } from '../primitives';

// Matches the installation-family pages (integration/Installation.js, installation/WordPress.js,
// installation/OtherCMS.js, installation/API.js): a readonly-fields card (API key/org/project id
// or docs card) followed by a platform tile grid and/or embed code block.
export default function InstallationSkeleton() {
    return (
        <div>
            <div style={{ border: '1px solid #E2E8F0', borderRadius: 10, padding: 24, marginBottom: 24 }}>
                {Array.from({ length: 3 }).map((_, i) => (
                    <div key={i} style={{ marginBottom: 14 }}>
                        <Bone h={11} w={100} style={{ marginBottom: 6 }} />
                        <Bone h={36} w="100%" />
                    </div>
                ))}
            </div>
            <Bone h={16} w={260} style={{ marginBottom: 16 }} />
            <SkeletonGrid cols={4} gap={12}>
                {Array.from({ length: 8 }).map((_, i) => <Bone key={i} h={90} r={10} />)}
            </SkeletonGrid>
        </div>
    );
}
